import { ModuleType } from 'global-services/constants/OhsObject';

import { getConfigValue, setPermissions } from '../OhsConfigServices';
import { OhsModuleConfig } from '../OhsModuleConfig';
import OhsModulePermissions from '../OhsModulePermissions';

class OhsWmmSysFieldsConfig implements OhsModuleConfig {
  TITLE: string;

  PERMISSIONS: OhsModulePermissions;

  MORPH_PERMISSIONS: OhsModulePermissions;

  ORG_RECORDS_ACCESS: boolean;

  USER_PROFILE: { type: string; _id: string };

  TYPE = ModuleType.Wmm;

  constructor(config: any) {
    this.TITLE = getConfigValue(config, 'TITLE');
    this.PERMISSIONS = new OhsModulePermissions(false);
    this.MORPH_PERMISSIONS = new OhsModulePermissions(false);
    this.ORG_RECORDS_ACCESS = getConfigValue(config, 'ORG_RECORDS_ACCESS');
    this.USER_PROFILE = getConfigValue(config, 'USER_PROFILE');
    setPermissions(this.PERMISSIONS, getConfigValue(config, 'PERMISSIONS'));
    setPermissions(this.PERMISSIONS, getConfigValue(config, 'MORPH_PERMISSIONS'));
  }
}

export default OhsWmmSysFieldsConfig;
